"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.resetXsrfToken = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

require("isomorphic-fetch");

var _store = _interopRequireDefault(require("./store"));

var _runtimeConfigHelper = _interopRequireDefault(require("./helpers/runtime-config-helper"));

var _brandHelper = _interopRequireDefault(require("./helpers/brand-helper"));

var _urlHelper = _interopRequireDefault(require("./helpers/url-helper"));

/* global fetch */
var _xsrfToken = null; // wrapper for every fetch action
// adding 'simpleCall' options. With this option, it would not auto inject
// any requests with X-XSRF-TOKEN.

var fetchWrapper =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(url, object) {
    var xsrfTokenFromState, method, xsrftokenName, fetchXsrfTokenSiteName, xsrfPreAuth, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            object = object || {}; // hack for credit card call, doesn't work with xrsf token

            if (!(url.indexOf('credit_card/auth') < 0 && !object.simpleCall)) {
              _context.next = 24;
              break;
            }

            xsrfTokenFromState = (0, _store["default"])().getState().auth && (0, _store["default"])().getState().auth.xsrfToken;

            if (!object.headers) {
              object.headers = {};
            }

            method = (object.method || 'GET').toUpperCase();

            if (!(method !== 'GET')) {
              _context.next = 24;
              break;
            }

            xsrftokenName = _runtimeConfigHelper["default"].getRuntimeConfig()._fetchXsrfTokenHeaderName || 'X-XSRF-TOKEN';

            if (!xsrfTokenFromState) {
              _context.next = 11;
              break;
            }

            object.headers[xsrftokenName] = xsrfTokenFromState;
            _context.next = 24;
            break;

          case 11:
            if (!_xsrfToken) {
              _context.next = 15;
              break;
            }

            object.headers[xsrftokenName] = _xsrfToken;
            _context.next = 24;
            break;

          case 15:
            if (_brandHelper["default"].isHostedBrand()) {
              _context.next = 24;
              break;
            }

            fetchXsrfTokenSiteName = _runtimeConfigHelper["default"].getRuntimeConfig()._fetchXsrfTokenSiteName;

            if (!fetchXsrfTokenSiteName) {
              _context.next = 24;
              break;
            }

            xsrfPreAuth = _urlHelper["default"].getUrl(_runtimeConfigHelper["default"].getRuntimeConfig()._fetchXsrfTokenSiteName, _runtimeConfigHelper["default"].getRuntimeConfig()._fetchXsrfTokenEndpoint);
            _context.next = 21;
            return fetch(xsrfPreAuth, {
              method: 'POST',
              headers: {
                'Accept-Language': 'en-us'
              },
              credentials: 'include'
            });

          case 21:
            result = _context.sent;
            _xsrfToken = result.headers.get(xsrftokenName);
            object.headers[xsrftokenName] = _xsrfToken;

          case 24:
            return _context.abrupt("return", fetch(url, object));

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchWrapper(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var resetXsrfToken = function resetXsrfToken() {
  _xsrfToken = undefined;
};

exports.resetXsrfToken = resetXsrfToken;
var _default = fetchWrapper;
exports["default"] = _default;